import { render, staticRenderFns } from "./AddOrUpdateArticle.vue?vue&type=template&id=49e63475&scoped=true"
import script from "./AddOrUpdateArticle.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateArticle.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateArticle.vue?vue&type=style&index=0&id=49e63475&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e63475",
  null
  
)

export default component.exports